import { Content, Footer } from "react-bulma-components"
import { useTranslation } from "react-i18next"
import { SUPPORT_MAILTO } from "../util/supportUrl"

export const RetroFooter = () => {
  const { t } = useTranslation();

  return (
    <Footer>
      <Content className="has-text-centered">
        <p>
          <strong>Retroboard</strong> by Jerold LLC.
          {" · "}
          <a href="/terms">{t("terms.footerLink")}</a>
          {" · "}
          <a href="/privacy">{t("privacy.footerLink")}</a>
          {" · "}
          <a href="/pricing">{t("pricing.footerLink")}</a>
          {" · "}
          <a href="/blog">{t("blog.footerLink")}</a>
          {" · "}
          <a href={SUPPORT_MAILTO}>{t("footer.support")}</a>
        </p>
      </Content>
    </Footer>
  )
}
